import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {NgControl} from '@angular/forms';
import {MAT_INPUT_VALUE_ACCESSOR} from '@angular/material/input';
import clearSpaces from './clear-spaces';

@Directive({
  selector: 'input[appClearSpacesInAutocomplete]',
  providers: [
    {
      provide: MAT_INPUT_VALUE_ACCESSOR,
      useExisting: ClearSpacesInAutocompleteDirective
    },
  ]
})
export class ClearSpacesInAutocompleteDirective {
  private realValue!: string;
  private element: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private control: NgControl,
  ) {
    this.element = this.elementRef.nativeElement;
  }

  get value(): string {
    return this.realValue;
  }

  @Input()
  set value(value: string) {
    this.realValue = clearSpaces(value);
    this.element.value = this.realValue;
    this.control.control?.setValue(this.realValue);
    this.control.control?.updateValueAndValidity();
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    this.realValue = clearSpaces(value);
    this.control.control?.setValue(this.realValue);
    this.control.control?.updateValueAndValidity();
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string): void {
    this.realValue = clearSpaces(value);
    this.element.value = this.realValue;
    this.control.control?.setValue(this.realValue);
    this.control.control?.updateValueAndValidity();
  }
}
